import { render, staticRenderFns } from "./CardDriver.vue?vue&type=template&id=488dac88&scoped=true&"
import script from "./CardDriver.vue?vue&type=script&lang=js&"
export * from "./CardDriver.vue?vue&type=script&lang=js&"
import style0 from "./CardDriver.vue?vue&type=style&index=0&id=488dac88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488dac88",
  null
  
)

export default component.exports